import * as React from "react";
import { Badge } from "components/bootstrap";
import NavBadgeItem from "components/navigation/NavBadgeItem";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import StringUtils from "util/StringUtils";
import HealthRoutes from "./Routes";
import { STATUS_BADGE_COLORS, STATUS_ICONS, STATUS_LABELS } from "./healthStatusCopy";
import { PROBLEM_STATUSES } from "./healthTree";
import { useHealthSummary } from "./useHealthModule";
import useHealthModuleVisible from "./useHealthModuleVisible";
const formatProblemBreakdown = (counts) => PROBLEM_STATUSES.filter((status) => counts[status] > 0).map((status) => `${counts[status]} ${status}`).join(", ");
const HealthStatusBadge = () => {
  const showHealthModule = useHealthModuleVisible();
  const { error, isLoading, overallStatus, problemCount, statusCounts, totalCheckCount } = useHealthSummary();
  const sendTelemetry = useSendTelemetry("cluster-health");
  if (!showHealthModule) return null;
  const displayStatus = error ? "unknown" : overallStatus;
  const showProblemCount = !error && !isLoading && problemCount > 0;
  const checks = `${totalCheckCount} ${StringUtils.pluralize(totalCheckCount, "check", "checks")}`;
  let healthLabel = showProblemCount ? `Cluster health: ${STATUS_LABELS[overallStatus]} \u2014 ${formatProblemBreakdown(statusCounts)} of ${checks}` : `Cluster health: ${STATUS_LABELS[overallStatus]} \u2014 all ${checks} passing`;
  if (isLoading) {
    healthLabel = "Cluster health: Loading";
  }
  if (error) {
    healthLabel = `Cluster health unavailable: ${error.message}`;
  }
  return /* @__PURE__ */ React.createElement(
    NavBadgeItem,
    {
      to: HealthRoutes.OVERVIEW,
      onClick: () => sendTelemetry(TELEMETRY_EVENT_TYPE.CLUSTER_HEALTH.BADGE_CLICKED, {
        event_details: { status: displayStatus, problem_count: showProblemCount ? problemCount : 0 }
      })
    },
    /* @__PURE__ */ React.createElement(
      Badge,
      {
        "aria-label": healthLabel,
        color: STATUS_BADGE_COLORS[displayStatus],
        "data-testid": "health-status-badge",
        leftIcon: STATUS_ICONS[displayStatus],
        title: healthLabel
      },
      showProblemCount ? problemCount : null
    )
  );
};
export default HealthStatusBadge;
